import React from 'react'
import Main from '../Components/DetailPage/Main'
import Header from '../Components/HomePage/Header'
import Menu from '../Components/ListingPage/Menu'

const Detail = () => {
  return (
    <div>
      <Header />
      <Menu />
      <Main />
    </div>
  )
}

export default Detail